// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oa-1";
export var messageSideRight = "_oa-2";
export var subscribeToBackInStockBubbleContainer = "_oa-0";